<template>
<div class="Vault">
    <v-speed-dial
        v-model="dial"
        fixed
        bottom
        right
        direction="top"
        transition="slide-y-reverse-transition"
    > 
        <template v-slot:activator>
            <v-btn
                v-model="search.show"
                color="deep-purple darken-4"
                dark
                fab
            >
                <v-icon v-if="dial">mdi-close</v-icon>
                <v-icon v-else>mdi-dots-horizontal</v-icon>
            </v-btn>
        </template>
        
        <v-btn 
            fab
            small
            color="success"
            dark
            @click="search.show = !search.show"
        >
            <v-icon>mdi-magnify</v-icon>
        </v-btn>
    </v-speed-dial>
    
    <v-navigation-drawer
        v-model="search.show"
        app
        right
    >
        <v-card
            v-if="search.show"
            flat
        >
            <v-card-title>
                Filtres<v-spacer/>
                <v-btn
                    title="Appliquer"
                    right
                    small
                    fab
                    icon
                    @click.stop="search.show = false"
                >
                    <v-icon>mdi-check</v-icon>
                </v-btn>

                <v-btn
                    title="Effacer les filtres"
                    right
                    small
                    fab
                    icon
                    @click.stop="clearSearchTool"
                >
                    <v-icon>mdi-cached</v-icon>
                </v-btn>
            </v-card-title>

            <v-card-text>
                <v-text-field 
                    v-model="search.text" 
                    label="Rechercher" 
                    class="mx-4"
                    prepend-icon="mdi-magnify"
                ></v-text-field>
            </v-card-text>
        </v-card>
    </v-navigation-drawer>

    <v-tabs 
        vertical
        color="deep-purple darken-4"
    >
        <v-tab 
            v-for="cabinet in tabs" 
            :key="`cabinet-tab-${cabinet[0]}`" 
            class="text-left"
            @click.prevent="tabChange(cabinet)"
        >{{ cabinet[1].title }}</v-tab>
    
        <v-tab-item v-for="cabinet in tabs" :key="`cabinet-content-${cabinet[0]}`">
            {{ cabinet[1].title }}
        </v-tab-item>
    </v-tabs>
</div>
</template>

<script>
export default {
    name: 'Vault',
    computed: {
        tabs() { return this.getChildren(this.focus) },
    },
    data: () => ({
        dial: false,
        breadcrumbs: [],
        search: {
            show: false,
            text: null,
        },
        focus: null, 
        currentTab: 0,
        cabinets: [
            [
                'ASDASD123213',
                {
                    title: 'Comptes payables',
                    icon: 'mdi-receipt'
                },
            ],
            [
                'ASDASD123215',
                {
                    title: 'Factures',
                    icon: 'mdi-receipt',
                    parent: 'ASDASD123213',
                },
            ],
            [
                'ASDASD123216',
                {
                    title: 'Bons de commande',
                    icon: 'mdi-receipt',
                    parent: 'ASDASD123213',
                },
            ],
        ],
    }),
    methods: {
        getChildren(parentId = null) {
            return Boolean(parentId) ? 
                this.cabinets.filter(cabinet => cabinet[1].parent === parentId) : 
                this.cabinets.filter(cabinet => !Boolean(cabinet[1].parent))
        },
        tabChange(e) {
            if(Boolean(this.getChildren(e[0]))) this.focus = e[0]
        },
        clearSearchTool() {
            this.search = {
                show: false,
                text: null,
                vendor: null,
            }
        },
    },
}
</script>

<style scoped>

</style>